module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-4-128.7ba9f2e6673281ea.jpg"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-4-128.7ba9f2e6673281ea.jpg",width: 128,height: 85}],
        src: "https://static.sniffspot.com/packs/img/bp-4-128.7ba9f2e6673281ea.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-4-128.7ba9f2e6673281ea.jpg"},
        
        width: 128,
        height: 85
      }